(function() {
    'use strict';

    angular
        .module('exportsApp')
        .controller('ExportsDeleteDialogController', ExportsDeleteDialogController);

    ExportsDeleteDialogController.$inject = ['$scope', '$uibModalInstance'];

    function ExportsDeleteDialogController($scope, $uibModalInstance) {
    	var deleteExportsCtr=this;
    	deleteExportsCtr.ok=function() {
    	    $uibModalInstance.close(true);
    	};

    	deleteExportsCtr.cancel=function() {
    	    $uibModalInstance.dismiss('cancel');
    	};
    }
})();
